import React from "react";
import { createCheckoutSession } from "./stripeFunctions";
import { useEffect } from "react";
import { useState } from "react";

const AddOnCard = ({ addOn, currentAddOns, setLoading }) => {
  const [isAddOnActive, setIsAddOnActive] = useState(false);
  const [qty, setQty] = useState(3);
  // console.log({ addOn, isAddOnActive, currentAddOns })

  useEffect(() => {
    const addOnExists = currentAddOns.some(
      (item) => item?.name === addOn?.name,
    );
    // console.log({addOnExists})
    if (addOnExists) {
      setIsAddOnActive(true);
    }
  }, [currentAddOns]);

  const handleUpgrade = async () => {
    setLoading(true);
    if (addOn.name === "indexmenow")
      createCheckoutSession(addOn.priceId, false, setLoading, qty);
    else createCheckoutSession(addOn.priceId, false, setLoading);
  };
  return (
    <div
      className="planCard"
      style={{
        border: isAddOnActive ? "2px solid #00B87C" : "none",
        justifyContent: "space-between",
      }}
      key={addOn?.name + "addOnCard"}
    >
      <div>
        {isAddOnActive && (
          <div style={{ textAlign: "center", marginBottom: "10px" }}>
            <span className="currentPlanText">Active</span>
          </div>
        )}
        <h1 className="planTitle">{addOn?.formattedName}</h1>

        <h3 className="planTitle planPrice">
          ${addOn?.price}{" "}
          <span style={{ fontSize: "0.8rem" }}>/ {addOn?.subscription}</span>
        </h3>
      </div>
      <p dangerouslySetInnerHTML={{ __html: addOn?.description }}></p>
      {addOn?.showQtyInput && (
        <div className="counter">
          <button
            className="down"
            onClick={() => {
              if (qty > 1) {
                setQty(qty - 1);
              }
            }}
          >
            -
          </button>
          <input
            type="number"
            value={qty}
            disabled
            onChange={(e) => setQty(e.target.value)}
          />
          <button className="up" onClick={() => setQty(qty + 1)}>
            +
          </button>
        </div>
      )}
      {/* <p>Limit : {addOn?.limit}</p> */}
      {(!isAddOnActive || addOn?.showQtyInput) && (
        <button
          className="upgradeBtn"
          onClick={handleUpgrade}
          key={addOn?.name + "upgradeButton"}
        >
          Add Now
        </button>
      )}
      {/* {planNo > 1 && currentPlan === planNo && isTrialPlan && (
            <button
              className='upgradeBtn'
              onClick={() => {
                endUserTrail();
              }}
            >
              Upgrade Now
            </button>
          )} */}
    </div>
  );
};

export default AddOnCard;
